<template>
  <div :class="rootClass">
    <b-row style="color: black">
      <b-tabs style="width: 100%">
        <b-tab title="Lịch sử ưu đãi" @click="changeTab(1)">
          <b-col cols="12">
            <b-row class="mb-2">
              <b-col lg="3" sm="12">
                <b-row align-v="center">
                  <label :class="rootClass + '__phone-number-label'"
                  >Số thuê bao:</label
                  >
                  <b-form-input
                      ref="inputSearchPhone"
                      v-model="searchPhone"
                      :class="rootClass + '__phone-number-input'"
                      disabled
                      v-on:keyup.enter="getMemberPackHis"
                  ></b-form-input>
                  <!--                  <b-button-->
                  <!--                      @click="getMemberPackHis()"-->
                  <!--                      variant="danger"-->
                  <!--                      :class="rootClass + '__search-voice-sms-data-btn'"-->
                  <!--                      class="redButton ml-2"-->
                  <!--                  >Tra cứu-->
                  <!--                  </b-button>-->
                </b-row>
              </b-col>
            </b-row>
            <b-row class="mb-1">
              <table :class="rootClass + '__history-voice-sms-data-table'">
                <tr style="height: 3rem;position: sticky">
                  <template v-for="(h, i) in memberTable.fields">
                    <th
                        :key="h.key"
                        :class="{
                        '--first-th': i === 0,
                        '--last-th': i === memberTable.fields.length - 1
                      }"
                        style="min-width: 80px"
                    >
                      {{ h.label }}
                    </th>
                  </template>
                </tr>
                <template v-for="(r, index) in memberHis">
                  <tr :key="index" style="color:black;">
                    <td>{{ index + 1 }}</td>
                    <td>{{ r.PackageName }}</td>
                    <td>{{ r.IsActive ? "Mở" : "Đóng" }}</td>
                    <td>{{ r.StartDate }}</td>
                    <td>{{ r.EndDate }}</td>
                    <td
                        style="width: 40vw;text-align: left"
                        v-html="r.Description"
                    ></td>
                  </tr>
                </template>
              </table>
            </b-row>
          </b-col>
        </b-tab>
        <b-tab title="Tra cứu ưu đãi đã nhận" @click="changeTab(2)">
          <b-col cols="12">
            <b-row class="mb-2">
              <b-col lg="3" sm="12">
                <b-row align-v="center">
                  <label :class="rootClass + '__phone-number-label'"
                  >Số thuê bao</label
                  >
                  <b-form-input
                      ref="inputSearchPhone"
                      v-model="searchPhone"
                      :class="rootClass + '__phone-number-input'"
                      disabled
                      v-on:keyup.enter="getHisRefund"
                  ></b-form-input>
                </b-row>
              </b-col>
              <b-col lg="3" sm="12" style="margin-left: -2%;">
                <b-row align-v="center">
                  <label :class="rootClass + '__from-date-label'"
                  >Từ ngày</label
                  >
                  <b-form-datepicker
                      v-model="fromDate"
                      :class="rootClass + '__from-date-input'"
                      :date-format-options="{
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit'
                    }"
                      locale="vi-VN"
                      style="font-size: 16px;font-weight: 500 !important;color: black !important;"
                  />
                </b-row>
              </b-col>
              <b-col lg="3" sm="12" style="margin-left: -3%;">
                <b-row align-v="center">
                  <label :class="rootClass + '__to-date-label'">Đến ngày</label>
                  <b-form-datepicker
                      v-model="toDate"
                      :class="rootClass + '__to-date-input'"
                      :date-format-options="{
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit'
                    }"
                      locale="vi-VN"
                      style="font-size: 16px;"
                  />
                </b-row>
              </b-col>
              <b-col
                  lg="2"
                  sm="12"
                  style="display: flex; align-items: center; max-width: 13%;margin-right: 4%"
              >
                <b-button
                    :class="rootClass + '__search-voice-sms-data-btn'"
                    class="redButton"
                    style="margin-left: -30%"
                    variant="danger"
                    @click="getHisRefund"
                >Tra cứu
                </b-button>
              </b-col>
              <b-col
                  lg="2"
                  sm="12"
                  style="display: flex; align-items: center; max-width: 13%;"
              >
                <b-button
                    :class="rootClass + '__export-voice-sms-data-btn'"
                    class="redButton"
                    variant="danger"
                    @click="exportExcel"
                ><span>
                    <feather-icon class="mr-50" icon="SaveIcon" size="16"
                    /></span>
                  Xuất file
                </b-button>
              </b-col>
            </b-row>
            <b-row class="mb-1">
              <table :class="rootClass + '__history-voice-sms-data-table'">
                <tr style="height: 3rem; border-bottom: 1px solid #ececec">
                  <template v-for="(h, i) in historyUseTable.fields">
                    <th
                        :key="i"
                        :class="{
                        '--first-th': i === 0,
                        '--last-th': i === historyUseTable.fields.length - 1
                      }"
                    >
                      {{ h.label }}
                    </th>
                  </template>
                </tr>
                <tr v-for="(ele, i) in memberPackList" :key="ele.id">
                  <td>{{ i + 1 }}</td>
                  <td>{{ ele.Phone }}</td>
                  <td>{{ ele.PackageName }}</td>
                  <td>{{ ele.MainPromoName }}</td>
                  <td>{{ ele.MainPromoValue }}</td>
                  <td>{{ ele.CreatedDate }}</td>
                </tr>
              </table>
            </b-row>
          </b-col>
        </b-tab>
        <b-tab title="Mở ưu đãi" @click="changeTab(3)">
          <b-col cols="12">
            <b-row class="mb-2">
              <b-col lg="3" sm="12">
                <b-row align-v="center">
                  <label :class="rootClass + '__phone-number-label'"
                  >Số thuê bao</label
                  >
                  <b-form-input
                      ref="inputSearchPhone"
                      v-model="searchPhone"
                      :class="rootClass + '__phone-number-input'"
                      disabled
                      v-on:keyup.enter="getListMemberPack"
                  ></b-form-input>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="mb-1">
              <table :class="rootClass + '__history-voice-sms-data-table'">
                <tr style="height: 3rem; border-bottom: 1px solid #ececec">
                  <template v-for="(h, i) in regMemberPackTable.fields">
                    <th
                        :key="i"
                        :class="{
                        '--first-th': i === 0,
                        '--last-th': i === regMemberPackTable.fields.length - 1
                      }"
                    >
                      {{ h.label }}
                    </th>
                  </template>
                </tr>
                <tr v-for="(ele, i) in regisPackList" :key="ele.Id">
                  <td>{{ i + 1 }}</td>
                  <td>{{ ele.Name }}</td>
                  <td>{{ ele.Period }} ngày</td>
                  <td>{{ ele.Price }}</td>
                  <td
                      style="width: 40vw;text-align: left"
                      v-html="ele.Description"
                  ></td>
                  <td>
                    <b-button
                        v-if="!ele.Active"
                        variant="primary"
                        @click="regisPack(ele.Id)"
                    >
                      Đăng ký ưu đãi
                    </b-button>
                    <b-button
                        v-else
                        variant="primary"
                        @click="openCancelModal(ele.Name)"
                    >
                      Hủy ưu đãi
                    </b-button>
                  </td>
                </tr>
              </table>
            </b-row>
            <b-row
                v-if="showErrSearchSpam"
                style="justify-content: center;font-size: 18px"
            >
              Không tìm thấy kết quả!
            </b-row>
          </b-col>
        </b-tab>
        <b-tab title="Lịch sử đóng ưu đãi" @click="changeTab(4)">
          <b-col cols="12">
            <b-row class="mb-2">
              <b-col lg="3" sm="12">
                <b-row align-v="center">
                  <label :class="rootClass + '__phone-number-label'"
                  >Số thuê bao</label
                  >
                  <b-form-input
                      ref="inputSearchPhone"
                      v-model="searchPhone"
                      :class="rootClass + '__phone-number-input'"
                      disabled
                      v-on:keyup.enter="getHisRefund"
                  ></b-form-input>
                </b-row>
              </b-col>
              <b-col lg="3" sm="12" style="margin-left: -2%;">
                <b-row align-v="center">
                  <label :class="rootClass + '__from-date-label'"
                  >Từ ngày</label
                  >
                  <b-form-datepicker
                      v-model="fromDate"
                      :class="rootClass + '__from-date-input'"
                      :date-format-options="{
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit'
                    }"
                      locale="vi-VN"
                      style="font-size: 16px;font-weight: 500 !important;color: black !important;"
                  />
                </b-row>
              </b-col>
              <b-col lg="3" sm="12" style="margin-left: -3%;">
                <b-row align-v="center">
                  <label :class="rootClass + '__to-date-label'">Đến ngày</label>
                  <b-form-datepicker
                      v-model="toDate"
                      :class="rootClass + '__to-date-input'"
                      :date-format-options="{
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit'
                    }"
                      locale="vi-VN"
                      style="font-size: 16px;"
                  />
                </b-row>
              </b-col>
              <b-col
                  lg="2"
                  sm="12"
                  style="display: flex; align-items: center; max-width: 13%;margin-right: 4%"
              >
                <b-button
                    :class="rootClass + '__search-voice-sms-data-btn'"
                    class="redButton"
                    style="margin-left: -30%"
                    variant="danger"
                    @click="getCancelHistory"
                >Tra cứu
                </b-button>
              </b-col>
            </b-row>
            <b-row class="mb-1">
              <table :class="rootClass + '__history-voice-sms-data-table'">
                <tr style="height: 3rem; border-bottom: 1px solid #ececec">
                  <template v-for="(h, i) in historyCancelTable.fields">
                    <th
                        :key="i"
                        :class="{
                        '--first-th': i === 0,
                        '--last-th': i === historyCancelTable.fields.length - 1
                      }"
                    >
                      {{ h.label }}
                    </th>
                  </template>
                </tr>
                <tr v-for="(ele, i) in historyCancelTableData" :key="ele.id">
                  <td>{{ i + 1 }}</td>
                  <td>{{ ele.RefId }}</td>
                  <td>{{ ele.PackageName }}</td>
                  <td>{{ ele.LogDate }}</td>
                  <td>{{ ele.Content }}</td>
                </tr>
              </table>
            </b-row>
            <b-row
                v-if="showErrSearchSpam"
                style="justify-content: center;font-size: 18px"
            >
              Không tìm thấy kết quả!
            </b-row>
          </b-col>
        </b-tab>
        <div
            v-if="currentTab === 2 || currentTab === 4"
            class="d-flex justify-content-end"
        >
          <b-pagination
              v-model="currentPage"
              :total-rows="totalRecords"
              per-page="20"
          ></b-pagination>
        </div>
      </b-tabs>
    </b-row>
    <!--    <b-modal id="regisMemberPackModal" title="Đăng ký gói member" size="xl" centered hide-footer>-->
    <!--      <iframe-->
    <!--          ref="iframeRef"-->
    <!--          id="iframeRegisMemberPackModal"-->
    <!--          :src="modalSrc"-->
    <!--          title="Đăng ký gói member"-->
    <!--          style="width: 100%; height: 100%; min-height: 85vh; border: none"-->
    <!--      ></iframe>-->
    <!--    </b-modal>-->
    <b-modal
        id="cancelPackModal"
        cancel-title="Đóng"
        centered
        ok-title="Hủy Ưu Đãi"
        size="sm"
        title="Thông báo"
        @ok="cancelPack"
    >
      <p>
        Bạn có chắc muốn hủy ưu đãi <b>{{ cancelPackName }}</b> cho số thuê bao
        <b>{{ this.searchPhone }}</b> ?
      </p>
    </b-modal>
    <b-modal
        v-if="activePack.length > 0"
        id="confirmRegisModal"
        cancel-title="Đóng"
        centered
        ok-title="Hủy Ưu Đãi Cũ"
        size="sm"
        title="Thông báo"
        @ok="cancelAndRegisPack()"
    >
      <p>
        Số TB {{ searchPhone }} đang trong chu kỳ sử dụng ưu đãi
        {{ activePack[0].PackageName }} từ ngày
        {{ activePack[0].StartDate }} đến ngày {{ activePack[0].EndDate }}. Khi
        mở ưu đãi mới, ưu đãi {{ activePack[0].PackageName }} đang sử dụng cũng
        sẽ đóng hết tất cả ưu đãi
      </p>
    </b-modal>
  </div>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BButtonGroup,
  BCard,
  BCol,
  BContainer,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BImg,
  BInputGroup,
  BInputGroupPrepend,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTab,
  BTable,
  BTabs,
  BTooltip
} from "bootstrap-vue";
import vSelect from "vue-select";
import DropMenu from "./DropMenu.vue";
import useJwt from "@/auth/jwt/useJwt";
import moment from "moment/moment";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axios from "axios";
import {$ctx} from "@themeConfig";
import * as Excel from "exceljs";
import {saveAs} from "file-saver";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    BModal,
    BFormGroup,
    BFormCheckbox,
    BImg,
    BButtonGroup,
    BInputGroup,
    BInputGroupPrepend,
    BTabs,
    BTab,
    BContainer,
    BFormDatepicker,
    DropMenu
  },
  data() {
    return {
      cancelPackName: "",
      currentTab: 1,
      currentPage: 1,
      totalRecords: 0,
      currentRegisPack: 0,
      rootClass: "search-crs",
      activePack: [],
      historyCancelTable: {
        fields: [
          {key: "stt", label: "STT"},
          {key: "RefId", label: "Số thuê bao"},
          {key: "PackageName", label: "Ưu đãi"},
          {key: "LogDate", label: "Thời gian đóng ưu đãi"},
          {key: "Content", label: "User thực hiện đóng ưu đãi"}
        ]
      },
      historyCancelTableData: [],
      fromDate: new Date(),
      toDate: new Date(),
      memberTable: {
        fields: [
          {key: "stt", label: "STT"},
          {key: "name", label: "Ưu đãi"},
          {key: "type", label: "Trạng thái"},
          {key: "discount", label: "Ngày bắt đầu"},
          {key: "start_date", label: "Ngày kết thúc"},
          {key: "end_date", label: "Nội dung ưu đãi"}
        ]
      },
      historyUseTable: {
        fields: [
          {key: "stt", label: "STT"},
          {key: "active_date", label: "Số thuê bao"},
          {key: "Msisdn", label: "Ưu đãi"},
          {key: "Active", label: "Loại ưu đãi"},
          {key: "chanel", label: "Chi tiết"},
          {key: "CreatedDate", label: "Thời gian nhận ưu đãi"}
        ]
      },
      regMemberPackTable: {
        fields: [
          {key: "stt", label: "STT"},
          {key: "Msisdn", label: "Tên ưu đãi"},
          {key: "topup_value", label: "Chu kỳ ưu đãi"},
          {key: "topup_time", label: "Giá ưu đãi"},
          {key: "chanel", label: "Nội dung ưu đãi"},
          {key: "status", label: "Thao tác"}
        ]
      },
      memberHis: [],
      regisPackList: [],
      memberPackList: [],
      regex087: /87\d{7}$/,
      showErrSearch: false,
      showErrSearchSpam: false,
      mgmCode: "",
      modalSrc: $ctx.URL_FRONTEND.includes("dev")
          ? "https://v3.itel.dev/deal-hot-goi-may"
          : "https://itel.vn/deal-hot-goi-may"
    };
  },
  props: {
    searchPhone: String
  },
  watch: {
    currentPage(val) {
      if (this.currentTab === 1) {
        this.getMemberPackHis();
      }
      if (this.currentTab === 2) {
        this.getHisRefund();
      }
      if (this.currentTab === 3) {
        this.getListMemberPack();
      }
    }
  },
  mounted() {
    this.$root.$on("bv::dropdown::show", bvEvent => {
      if (bvEvent.componentId === "dropdown-2") {
        this.isDropdown2Visible = true;
      }
    });
    this.$root.$on("bv::dropdown::hide", bvEvent => {
      if (bvEvent.componentId === "dropdown-2") {
        this.isDropdown2Visible = false;
      }
      if (this.isDropdown2Visible) {
        bvEvent.preventDefault();
      }
    });
    this.getMemberPackHis();
  },
  computed: {},
  methods: {
    openConfirmRegisModal() {
      this.$bvModal.show("confirmRegisModal");
    },
    regisPack(packId) {
      this.currentRegisPack = packId;
      if (this.activePack.length > 0) {
        this.openConfirmRegisModal();
      } else {
        this.redirectRegisPack();
      }
    },
    redirectRegisPack() {
      window
          .open(
              this.modalSrc +
              `/payment?id=${this.currentRegisPack}&phone=${this.searchPhone}`,
              "_blank"
          )
          .focus();
    },
    async cancelAndRegisPack() {
      await this.cancelPack();
      this.redirectRegisPack();
    },

    openCancelModal(packName) {
      this.cancelPackName = packName;
      this.$bvModal.show("cancelPackModal");
    },
    async cancelPack() {
      this.showLoading("block");
      await useJwt
          .get("membership/cancel-membership/" + this.searchPhone)
          .then(response => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message,
                icon: "CheckIcon",
                variant: "success"
              }
            });
            this.showLoading("none");
            this.getListMemberPack();
          })
          .catch(error => {
            this.showLoading("none");
            this.$toast({
              component: ToastificationContent,
              props: {
                title: error.response.data.message,
                icon: "CheckIcon",
                variant: "success"
              }
            });
            console.log(error);
          });
    },
    changeTab(tab) {
      this.currentPage = 1;
      this.currentTab = tab;
      if (tab === 1) {
        this.getMemberPackHis();
      }
      if (tab === 2) {
        this.getHisRefund();
      }
      if (tab === 3) {
        this.getListMemberPack();
      }
      if (tab === 4) {
        this.getCancelHistory();
      }
    },
    getCancelHistory() {
      this.showLoading("block");
      useJwt
          .post("membership/get-cancel-history", {
            phone: this.searchPhone,
            page: this.currentPage,
            pageSize: 20,
            fromDate: moment(this.fromDate).format("DD-MM-YYYY"),
            toDate: moment(this.toDate).format("DD-MM-YYYY")
          })
          .then(response => {
            this.showLoading("none");
            this.historyCancelTableData = response.data.result;
            this.historyCancelTableData.forEach((item, index) => {
              item.LogDate = moment(item.LogDate).format("DD/MM/YYYY HH:mm:ss");
            });
            this.totalRecords = response.data.totalRecords;
          })
          .catch(error => {
            this.showLoading("none");
            console.log(error);
          });
    },
    async exportExcel() {
      if (this.memberPackList.length === 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Không có dữ liệu để xuất file",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }
      this.showLoading("block");
      const workbook = new Excel.Workbook();
      const worksheet = workbook.addWorksheet("Sheet1");
      worksheet.columns = [
        {key: "stt", header: "STT"},
        {key: "Phone", header: "Số thuê bao"},
        {key: "PackageName", header: "Gói Member"},
        {key: "MainPromoName", header: "Loại ưu đãi"},
        {key: "MainPromoValue", header: "Chi tiết"},
        {key: "CreatedDate", header: "Thời gian nhận ưu đãi"}
      ];
      this.memberPackList.forEach((item, index) => {
        worksheet.addRow({
          stt: index + 1,
          Phone: item.Phone,
          PackageName: item.PackageName,
          CreatedDate: item.CreatedDate,
          MainPromoName: item.MainPromoName,
          MainPromoValue: item.MainPromoValue
        });
      });
      const buffer = await workbook.xlsx.writeBuffer();
      const fileType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      const fileExtension = ".xlsx";
      const blob = new Blob([buffer], {type: fileType});
      const fileName =
          "MemberShip-" +
          this.searchPhone +
          "-" +
          moment(this.fromDate).format("DD/MM/YYYY") +
          "-" +
          moment(this.toDate).format("DD/MM/YYYY") +
          fileExtension;
      saveAs(blob, fileName);
      this.showLoading("none");
    },
    async getMemberPackHis() {
      this.showLoading("block");
      await useJwt
          .get("membership/get-register-history/" + this.searchPhone)
          .then(response => {
            this.showLoading("none");
            this.memberHis = response.data.result.historyMembership;
            this.activePack = response.data.result.activeMembership;
            this.memberHis.forEach((item, index) => {
              item.StartDate = moment(item.StartDate).format(
                  "DD/MM/YYYY HH:mm:ss"
              );
              item.EndDate = moment(item.EndDate).format("DD/MM/YYYY HH:mm:ss");
            });
            this.activePack.forEach((item, index) => {
              item.StartDate = moment(item.StartDate).format("DD/MM/YYYY");
              item.EndDate = moment(item.EndDate).format("DD/MM/YYYY");
            });
            this.totalRecords = response.data.totalRecords;
          })
          .catch(error => {
            this.showLoading("none");
            console.log(error);
          });
    },
    // commit
    getHisRefund() {
      this.showLoading("block");
      useJwt
          .post("membership/get-refund-history/" + this.searchPhone, {
            page: this.currentPage,
            pageSize: 20,
            fromDate: moment(this.fromDate).format("DD-MM-YYYY"),
            toDate: moment(this.toDate).format("DD-MM-YYYY")
          })
          .then(response => {
            this.showLoading("none");
            this.memberPackList = response.data.result.listRefund;
            this.memberPackList.forEach((item, index) => {
              item.ExtendDate = moment(item.ExtendDate).format(
                  "DD/MM/YYYY HH:mm:ss"
              );
              item.CreatedDate = moment(item.CreatedDate).format(
                  "DD/MM/YYYY HH:mm:ss"
              );
              if (item.MainPromoType === 1) {
                item.MainPromoValue = item.MainPromoValue.toLocaleString(
                    "it-IT",
                    {style: "currency", currency: "VND"}
                );
              }
            });
            this.totalRecords = response.data.totalRecords;
          })
          .catch(error => {
            this.showLoading("none");
            console.log(error);
          });
    },
    async getListMemberPack() {
      this.showLoading("block");
      await axios
          .post(
              $ctx.URL_FRONTEND.includes("dev")
                  ? "https://itel.dev/api/web/membership/get-membership-package"
                  : "https://itel.vn/api/web/membership/get-membership-package",
              {
                packageId: null
              }
          )
          .then(async response => {
            await this.getMemberPackHis();
            this.regisPackList = response.data.result;
            this.regisPackList.forEach(item => {
              item.StartTime = moment(item.StartTime).format(
                  "DD/MM/YYYY HH:mm:ss"
              );
              item.UpdatedDate = moment(item.UpdatedDate).format(
                  "DD/MM/YYYY HH:mm:ss"
              );
              item.Price = item.Price.toLocaleString("it-IT", {
                style: "currency",
                currency: "VND"
              });
            });
            this.regisPackList.forEach(item => {
              item.Active = !!this.activePack.find(e => e.PackageId === item.Id);
            });
            this.totalRecords = response.data.totalRecords;
            this.showLoading("none");
          })
          .catch(error => {
            this.showLoading("none");
            console.log(error);
          });
    },
    showLoading(options) {
      document.getElementById("loading-bg").style.display = options;
    }
  }
};
</script>

<style lang="scss" scoped>
.removeFocus:focus {
  outline: none;
}

.search-crs {
  position: relative;
  font-size: 16px;
  font-family: "Times New Roman";
  min-height: 500px;

  &__card {
    border-radius: 2rem;
    background: #fcfcfc;
  }

  &__func-group-btns {
    border: 1px solid red;
    border-radius: 40px;
    height: 38px;
  }

  &__subscriber-information-btn {
    border-radius: 40px;
    font-weight: 800;
    color: #707070 !important;
    background: transparent !important;
    border: transparent;
    padding: 0.2rem 1.5rem;
  }

  &__search-crs-btn {
    border-radius: 40px !important;
    color: white;
    width: 195px;
    padding: 0.2rem 1.5rem;
  }

  &__phone-number-label {
    font-weight: 500;
    color: black;
    font-size: 14px;
    margin-right: 0.3rem;
    width: 80px;
  }

  &__phone-number-input {
    font-weight: 500;
    color: black;
    font-size: 14px;
    width: 200px;
  }

  &__from-date-label {
    font-weight: 500;
    color: black;
    font-size: 14px;
    margin-right: 0.3rem;
    width: 70px;
  }

  &__from-date-input {
    width: 200px;
  }

  &__to-date-label {
    font-weight: 500;
    color: black;
    font-size: 14px;
    margin-right: 0.3rem;
    width: 70px;
  }

  &__to-date-input {
    width: 200px;
  }

  &__search-voice-sms-data-btn {
    border-radius: 40px;
    //font-size: 10px;
  }

  &__history-voice-sms-data-table {
    background: white;
    border-radius: 16px;
    width: 100%;
    text-align: center;

    tr {
      height: 30px;
    }

    tr th,
    tr td {
      border: 0.299185px solid rgba(184, 184, 184, 0.5);
    }

    th {
      background-color: #ed1f24;
      color: white;
    }

    .--first-th {
      border-radius: 12px 0px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--last-th {
      border-radius: 0px 12px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--first-td {
      border-right: unset;
      border-left: unset;
    }

    .--last-td {
      border-right: unset;
      border-left: unset;
    }
  }

  &__export-voice-sms-data-btn {
    border-radius: 40px;
  }

  &__search-spam-btn {
    border-radius: 40px;
    font-size: 10px;
  }

  &__history-spam-table {
    background: white;
    border-radius: 16px;
    width: 100%;
    text-align: center;

    tr {
      height: 30px;
    }

    tr th,
    tr td {
      border-right: 0.299185px solid rgba(184, 184, 184, 0.5);
      border-left: 0.299185px solid rgba(184, 184, 184, 0.5);
    }

    tr td {
      color: black;
    }

    .--first-th {
      border-radius: 12px 0px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--last-th {
      border-radius: 0px 12px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--first-td {
      border-right: unset;
      border-left: unset;
    }

    .--last-td {
      border-right: unset;
      border-left: unset;
    }
  }

  &__menu-right-group {
    position: absolute;
    top: 60px;
    right: 20px;
  }
}

.redButton {
  background-color: #ed1f24 !important;
  border-color: #ed1f24 !important;
}

@media screen and (max-width: 576px) {
  .search-crs {
    &__phone-number-label {
      width: 100%;
    }

    &__phone-number-input {
      width: 100%;
    }

    &__from-date-label {
      width: 100%;
    }

    &__from-date-input {
      width: 100%;
    }

    &__to-date-label {
      width: 100%;
    }

    &__to-date-input {
      width: 100%;
    }
  }
}
</style>
